import { Search } from '@vtex/shoreline'
import { t } from 'i18next'

import BadgeIsValid from '~/components/BadgeIsValid'
import Panel from '~/components/Panel'
import { FormGroup, Radio } from '~/components/unform'

import { useCampaignForm } from '../../hooks/useCampaignForm'
import { useDestinationRetailer } from './useDestinationRetailer'

type DestinationRetailerProps = {
  initialCollapsibleState?: boolean
}

const DestinationRetailer = ({
  initialCollapsibleState
}: DestinationRetailerProps) => {
  const {
    searchValue,
    setSearchValue,
    isPending,
    publishersFiltered,
    handleChoosePublishers
  } = useDestinationRetailer()
  const { allowOffsiteBriefing, selectedSubpublishers = [] } = useCampaignForm()
  const isSelected = selectedSubpublishers.length > 0

  // An advertiser is used to seeing every publisher it is linked to, so a
  // missing one reads as a bug rather than a rule — the list here is
  // narrowed to retailers that can actually take offsite traffic
  // (2026-09-15 demo, SPEC 004 item 2.1). The caveat only belongs to the
  // new flow: without the permission this panel is not narrowed, and
  // stating otherwise would be false.
  const baseDescription = t('rm:destinationRetailer.panel.description')
  const offsiteNote = t('rm:destinationRetailer.panel.offsiteNote')
  const description = allowOffsiteBriefing
    ? `${baseDescription} ${offsiteNote}`
    : baseDescription

  return (
    <Panel
      title={t('rm:destinationRetailer.panel.title')}
      description={description}
      isLoading={isPending}
      isCollapsible
      initialCollapsibleState={initialCollapsibleState}
      iconLeft={<BadgeIsValid isValid={isSelected} />}
    >
      <Search
        value={searchValue}
        onChange={e => setSearchValue(e.target.value)}
        onClear={() => setSearchValue('')}
        messages={{
          placeholder: t('rm:destinationRetailer.panel.search.placeholder')
        }}
        className="mb-2"
      />
      <FormGroup style={{ maxHeight: '400px', overflowY: 'scroll' }}>
        <Radio
          options={publishersFiltered}
          onChange={handleChoosePublishers}
          name="publisher_ids"
          required
        />
      </FormGroup>
    </Panel>
  )
}

export default DestinationRetailer
